import { Culture } from '../../types';

export const pascuaYaqui: Culture = {
  name: 'Pascua Yaqui',
  languageFamily: 'Uto-Aztecan',
  terms: [
    {
      word: 'Hiaki',
      phonetic: 'hee-ah-kee',
      description: 'Yaqui name for themselves, meaning "The People."'
    },
    {
      word: 'Hiapsi',
      phonetic: 'hee-ahp-see',
      description: 'Pascua Yaqui word for "life."'
    },
    {
      word: 'Itom',
      phonetic: 'ee-tohm',
      description: 'The Pascua Yaqui word for themselves, meaning "The People."'
    },
    {
      word: 'Itom Aye',
      phonetic: 'ee-tom ah-yeh',
      description: 'Phrase meaning "Our Land."'
    },
    {
      word: 'Maso',
      phonetic: 'mah-so',
      description: 'Pascua Yaqui word for "deer."'
    },
    {
      word: 'Nookam',
      phonetic: 'noo-kahm',
      description: 'Word meaning "spirit" or "soul."'
    },
    {
      word: 'Seewa',
      phonetic: 'see-wah',
      description: 'Pascua Yaqui word for "flower."'
    },
    {
      word: 'Siime',
      phonetic: 'see-meh',
      description: 'Pascua Yaqui word for "flower."'
    },
    {
      word: 'Tekia',
      phonetic: 'teh-kee-ah',
      description: 'Word for "home" or "shelter."'
    },
    {
      word: 'Yoeme',
      phonetic: 'yoh-eh-meh',
      description: 'Pascua Yaqui word for "person" or "people."'
    }
  ]
};